import React, { useEffect, useState } from "react";
import { X, Download } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) { setInstalled(true); return; }

    const lastShown = parseInt(localStorage.getItem("icard_install_last") || "0", 10);
    const dismissed = lastShown && (Date.now() - lastShown) < 7 * 24 * 60 * 60 * 1000;

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (!dismissed) {
        setTimeout(() => setShow(true), 10_000);
      }
    };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", () => { setInstalled(true); setShow(false); });

    // iOS fallback prompt (no beforeinstallprompt)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS && !dismissed && !isStandalone) {
      setTimeout(() => setShow(true), 10_000);
    }

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) { setShow(false); return; }
    deferred.prompt();
    await deferred.userChoice;
    setShow(false);
    setDeferred(null);
  };

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("icard_install_last", String(Date.now()));
  };

  if (installed || !show) return null;

  return (
    <div data-testid="install-prompt" className="fixed bottom-[calc(1rem+env(safe-area-inset-bottom))] left-4 right-4 sm:left-auto sm:right-4 sm:bottom-4 sm:max-w-sm z-[100] fade-in">
      <div className="bg-[#0A0A0A] text-white rounded-2xl p-4 shadow-2xl border border-white/10">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#7C3AED] flex items-center justify-center font-display font-black text-xl">i</div>
          <div className="flex-1">
            <div className="font-display font-bold text-base">Install iCaard</div>
            <div className="text-xs text-white/70 mt-0.5">Faster access, payments, and QR services.</div>
          </div>
          <button data-testid="install-prompt-close" onClick={dismiss} className="text-white/60 hover:text-white">
            <X size={18} />
          </button>
        </div>
        <div className="flex gap-2 mt-3">
          <button data-testid="install-prompt-install-btn" onClick={install} className="flex-1 bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-sm font-semibold py-2.5 rounded-lg flex items-center justify-center gap-1.5">
            <Download size={14} /> Add to Home Screen
          </button>
          <button data-testid="install-prompt-later-btn" onClick={dismiss} className="px-4 text-sm text-white/80 hover:text-white">Not now</button>
        </div>
      </div>
    </div>
  );
}
